export default __webpack_public_path__ + "static/media/limit_15.45745b66.svg";